import type { QuantityFlagItem, QuantityFlagMetadata } from "../PointMetadata";
import { QUANTITY_FLAG_METADATA } from "../PointMetadata";
import { color } from "@ui";
import t from "../../../../i18n";
import { zIndexChart } from "@ui/Highcharts/BetterHighcharts";
import type { ActiveAnalysis } from "../../../../api/useActiveAnalysesStream";
import { MARKER_SVG_INVALID } from "./getQuantityFlagSerie";
import type { MetrologyOverrides } from "../../../../api/useMetrologyOverrides";
import type { Quantity } from "../../../../api/useQuantities";
import { isAnalysisQuantityValid } from "../../metrology";
export const INVALID_QUANTITY_FLAG_SERIE_ID = "INVALID_QUANTITY_FLAG_SERIE_ID";
export const FLAG_AXIS = {
  id: "flagAxis",
  visible: false,
  zoomEnabled: false,
  max: 1,
};

const invalidMarker = {
  symbol: `url(${MARKER_SVG_INVALID})`,
  radius: 5,
  lineColor: color.hydrogen,
};

function getPoints(
  analyses: ActiveAnalysis[],
  quantities: Quantity[],
  _metrologyOverrides: MetrologyOverrides,
) {
  return analyses.reduce<Highcharts.PointOptionsObject[]>((acc, analysis) => {
    const quantityFlags = quantities.reduce<QuantityFlagItem[]>((res, quantity) => {
      if (!isAnalysisQuantityValid(analysis, quantity))
        res.push({
          name: quantity.name,
          type: "invalidValue",
          description: t("measures.chart.tooltip.description.invalid"),
          origin: "measured",
        });
      return res;
    }, []);

    if (!quantityFlags.length) return acc;

    const custom: QuantityFlagMetadata = {
      type: QUANTITY_FLAG_METADATA,
      group: analysis.group,
      label: analysis.label,
      flags: quantityFlags,
      human: null,
    };

    acc.push({
      id: `analysis-id-${analysis.id}`,
      x: analysis.date,
      custom,
      y: 0,
      marker: invalidMarker,
    });

    return acc;
  }, []);
}

function getInvalidQuantityFlagSerie({
  analyses,
  quantities,
  metrologyOverrides,
}: {
  analyses: ActiveAnalysis[];
  quantities: Quantity[];
  metrologyOverrides: MetrologyOverrides;
}): Highcharts.SeriesScatterOptions {
  return {
    id: INVALID_QUANTITY_FLAG_SERIE_ID,
    name: "",
    data: getPoints(analyses, quantities, metrologyOverrides),
    yAxis: FLAG_AXIS.id,
    replicateInNavigator: false,
    type: "scatter",
    color: "transparent", // hide hallow effect on point hover
    zIndex: zIndexChart.flagSeries,
  };
}

export default getInvalidQuantityFlagSerie;
